import React from "react";
import "./Postcard.css";
import { useNavigate } from "react-router-dom";

export default function PostCard({ post }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/post/${post.id}`);
  };

  return (
    <div className="CardPadding PostCard" onClick={handleClick}>
      <div className="ImageWrapper">
        <img src={post.image_url} alt={post.image_url} className="imageStyle" />
        <div className="Overlay"></div>
        <div className="TextWrapper">
          <div className="special-gothic-expanded-one-regular">
            {post.title}
          </div>
          <div className="bottom-right" style={{ whiteSpace: "pre-wrap" }}>
            {post.description}
          </div>
        </div>
      </div>
    </div>
  );
}
